// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"38":"00d85daf","136":"00d85daf"}[chunkId] + ".css";
};